import { NgModule } from '@angular/core';
import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';
import { DATA_ACCESS_CHECKOUT_FEATURE_KEY, reducers } from './reducers';
import { BasketEffects } from './effects/basket';
import { DirectDebitEffects } from './effects/direct-debit';
import { ImageEffects } from './effects/image';
import { PostcodeChildTicketVerifyEffects } from './effects/postcode-child-ticket-verify';
import { CompleteCheckoutEffects } from './effects/complete-checkout';
import { GtmEffects } from './effects/gtm/gtm.effects';

@NgModule({
  imports: [
    StoreModule.forFeature(DATA_ACCESS_CHECKOUT_FEATURE_KEY, reducers),
    EffectsModule.forFeature([
      BasketEffects,
      DirectDebitEffects,
      ImageEffects,
      PostcodeChildTicketVerifyEffects,
      CompleteCheckoutEffects,
      GtmEffects,
    ]),
  ],
})
export class CheckoutStoreModule {}
